import {REQUEST_CONFIRMATION_ACTION, CANCEL_CONFIRMATION_ACTION} from '../constants';

const pendingConfirmationReducer = (state = null, action) => {
    switch (action.type) {
        case REQUEST_CONFIRMATION_ACTION:
            const {pendingConfirmationAction, msg, pendingConfirmationCallback} = action;
            return {
                pendingConfirmationAction,
                msg,
                pendingConfirmationCallback,
            };
        case CANCEL_CONFIRMATION_ACTION:
            return null;
        default:
            return state;
    }
};

export default pendingConfirmationReducer;
